<form class="flex flex-wrap" [formGroup]="formPersonal">


  <div class="form-control md:w-2/3 w-full">
    <input class="form-field" type="text" id="observacao" formControlName="observacao" placeholder="" maxlength="300" multiple  />
    <label class="form-label" for="observacao">Observação</label>
    <error-field [control]="formPersonal.controls['observacao']"
      [errorMessages]="validationMessages.observacao">
    </error-field>
  </div>

  <div class="form-control md:w-1/3 w-full">
    <ng-select class="form-field" type="text" id="motivoViagem" formControlName="motivoViagem"
      [items]="motivoViagemList" bindLabel="label" bindValue="value">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        {{item.label}}
      </ng-template>

    </ng-select>
    <label class="form-label" for="motivoViagem">Motivo da viagem</label>
    <error-field [control]="formPersonal.controls['motivoViagem']" [errorMessages]="validationMessages.motivoViagem">
    </error-field>
  </div>

  <div class="form-control md:w-1/3 w-full">
    <ng-select class="form-field" type="text" id="transporteUtilizado" formControlName="transporteUtilizado"
      [items]="transporteUtilizadoList" bindLabel="label" bindValue="value">
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        {{item.label}}
      </ng-template>

    </ng-select>
    <label class="form-label" for="transporteUtilizado">Transporte utilizado</label>
    <error-field [control]="formPersonal.controls['transporteUtilizado']" [errorMessages]="validationMessages.transporteUtilizado">
    </error-field>
  </div>

  <div class="flex flex-row w-full justify-end items-center gap-1">
    <button class="btn btn-secondary" type="button" (click)="onCancel()">Cancelar</button>
    <button class="btn btn-primary" type="submit" (click)="onSave()">Salvar</button>
  </div>

</form>
